import { render } from "./NavFooter.vue?vue&type=template&id=990fe8da&scoped=true"
import script from "./NavFooter.vue?vue&type=script&lang=js"
export * from "./NavFooter.vue?vue&type=script&lang=js"

import "./NavFooter.vue?vue&type=style&index=0&id=990fe8da&scoped=true&lang=css"

import exportComponent from "/home/regie/projects-2.0/cia-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990fe8da"]])

export default __exports__